import { useGetIdentity } from "@refinedev/core";
import { Navigate, useParams } from "react-router";

import type { UserInfo } from "../types/auth";
import { ADMIN_USER_TYPES } from "../types/auth";
import { LoadingSpinner } from "./common/LoadingSpinner";

/**
 * Neutral landing route for ticket links (used by email notifications).
 *
 * Emails go out to a mixed audience — admins/support and the auditor
 * who opened the thread — so the notification cannot hard-code either
 * `/admin/tickets/<id>` (auditor guards bounce) or
 * `/auditor/incidences/<id>` (admin guards bounce). This component
 * reads the current identity and forwards to whichever detail route
 * the guards will accept.
 */
export const TicketRedirect = () => {
  const { id } = useParams<{ id: string }>();
  const { data: identity, isLoading } = useGetIdentity<UserInfo>();

  if (isLoading) {
    return <LoadingSpinner fullScreen tip="Redirigiendo…" />;
  }

  const userType = identity?.app_user?.user_type;
  const isAdmin =
    userType !== undefined &&
    (ADMIN_USER_TYPES as readonly number[]).includes(userType);

  const target = isAdmin
    ? `/admin/tickets/${id}`
    : `/auditor/incidences/${id}`;
  return <Navigate to={target} replace />;
};
